/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Input_No_ResultsInputs */

const es_user_input_no_results = /** @type {(inputs: User_Input_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron usuarios`)
};

const en_user_input_no_results = /** @type {(inputs: User_Input_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found`)
};

/**
* | output |
* | --- |
* | "No users found" |
*
* @param {User_Input_No_ResultsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_input_no_results = /** @type {((inputs?: User_Input_No_ResultsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Input_No_ResultsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_input_no_results(inputs)
	return en_user_input_no_results(inputs)
});
export { user_input_no_results as "user_input.no_results" }